// Loads Plaid Link from Plaid's CDN on demand and opens it.
const SRC = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
let loading = null;

export function loadPlaidLink() {
  if (window.Plaid) return Promise.resolve(window.Plaid);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SRC;
      s.async = true;
      s.onload = () => (window.Plaid ? resolve(window.Plaid) : reject(new Error('Plaid Link did not load')));
      s.onerror = () => { loading = null; reject(new Error('Plaid Link did not load')); };
      document.head.appendChild(s);
    });
  }
  return loading;
}

// Resolves with { publicToken, metadata } on success, null if the user exits.
// receivedRedirectUri resumes Link after an OAuth bank redirect.
export async function openPlaidLink(token, { receivedRedirectUri } = {}) {
  const Plaid = await loadPlaidLink();
  return new Promise((resolve) => {
    const handler = Plaid.create({
      token,
      ...(receivedRedirectUri ? { receivedRedirectUri } : {}),
      onSuccess: (publicToken, metadata) => { handler.destroy(); resolve({ publicToken, metadata }); },
      onExit: () => { handler.destroy(); resolve(null); },
    });
    handler.open();
  });
}
